import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Localiser} from "../../../services/localiser";
import {proyecto} from "../../../models/proyecto";
import {zona} from "../../../models/zona";
import {filter} from "rxjs/operators";

@Component({
  selector: 'app-selection-print',
  templateUrl: './selection-print.component.html',
  styleUrls: ['./selection-print.component.css']
})
export class SelectionPrintComponent implements OnInit {

  selected: selected[] = [];
  proyectos = [];
  zonas: zona[][] = [];

  constructor(public localiser: Localiser, public dialogRef: MatDialogRef<SelectionPrintComponent>,
              @Inject(MAT_DIALOG_DATA) public data: {proyectos, zonas: zona[][]}
  ) { }

  ngOnInit(): void {
    this.proyectos = this.data.proyectos;
    this.zonas = this.data.zonas;
  }

  changeProyecto(proyecto, event) {
    if (event == true) {
      this.selected.push(new selected(proyecto, this.zonas[this.proyectos.indexOf(proyecto)]));
    } else {
      for (let selection of this.selected) {
        if (selection.existsProyecto(proyecto)) {
          this.selected = this.selected.filter(select => !select.existsProyecto(proyecto));
        }
      }
    }
  }

  isProyectoChecked(proyecto) {
    for (let selection of this.selected) {
      if (selection.proyecto.idProyecto == proyecto.idProyecto) {
        return selection.zonas.length > 0;

      }
    }
    return false;
  }

  changeZona(proyecto, zona, event) {
    if (event == true) {
      for (let selection of this.selected) {
        if (selection.existsProyecto(proyecto)) {
          this.selected[this.selected.indexOf(selection)].addZona(zona);
          return
        }
      }
      this.selected.push(new selected(proyecto,
        this.zonas[this.proyectos.indexOf(proyecto)].filter(z => z.id == zona.id)));
    } else {
      for (let selection of this.selected) {
        if (selection.existsProyecto(proyecto) && selection.existsZona(zona)) {
          this.selected[this.selected.indexOf(selection)].removeZona(zona);
          if (this.selected[this.selected.indexOf(selection)].zonas.length <= 0) {
            this.selected = this.selected.filter(select => !select.existsProyecto(proyecto));
          }
        }
      }
    }
  }

  isZonaChecked(proyecto, zona) {
    for (let selection of this.selected) {
      if (selection.proyecto.idProyecto == proyecto.idProyecto) {
        for (let zonaS of selection.zonas) {
          if (zonaS.id == zona.id) {
            return true;
          }
        }
      }
    }
    return false;
  }

  onCancelClick(): void {
    this.dialogRef.close({action: false, selected: "no data"});
  }

  onStartClick(): void {
    this.dialogRef.close({action: true, selected: this.selected});
  }


}

export class selected {
  proyecto: proyecto;
  zonas: zona[];


  constructor(proyecto: proyecto, zonas: zona[]) {
    this.proyecto = proyecto;
    this.zonas = zonas;
  }

  public existsProyecto(proyecto) {
    return this.proyecto.idProyecto == proyecto.idProyecto;
  }

  public existsZona(zona) {
    return this.zonas.includes(zona);
  }

  public addZona(zona) {
    this.zonas.push(zona);
  }

  public removeZona(zona) {
    this.zonas = this.zonas.filter(z => z != zona);
  }

}
